import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal, CInputTextArea } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { AddJobsGroupApi, GetInputJobsGroupApi, AddDaynamicFieldJobsGroupApi } from "../../../api";
import { useNavigate, Link } from "react-router-dom";

export const JobGroupsAdd = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const [settingsField, setSettingsField] = useState<any>([])

    const addDynamicFeilds = async (job_group_id: number) => {
        await AddDaynamicFieldJobsGroupApi(settingsField, formRef, job_group_id)
        CtxLoad.setDisplayLoadingBtn(false)
        toast("با موفقیت افزوده شد", { type: "success" })
        navigate('/p/settings/job-groups');
    }


    const onFinishAdd = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await AddJobsGroupApi(formRef)
        if (res.success) {
            addDynamicFeilds(res.data.id)
        }
        else {
            toast(res.message, { type: "error" })
        }
    }


    const getInputs = async () => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await GetInputJobsGroupApi()
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.settings) {
            setSettingsField(res.settings)
        }
    }


    useEffect(() => {
        document.title = "ایجاد گروه شغلی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 0, })
        getInputs()
    }, [])

    return (
        <form ref={formRef} onSubmit={onFinishAdd} className=" w-full flex flex-col">

            <div className="w-full flex flex-col">
                <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">اضافه کردن گروه‌شغلی</h1>
                <div className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">

                    <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                        <div className=" w-full   flex flex-col sm:flex-row items-center">
                            <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                                <div className=" w-full h-full pl-1">
                                    <CInputText name="name" title="عنوان گروه شغلی" type="text" required={true} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                        <div className=" w-full   flex flex-col sm:flex-row items-center">
                            <div className=" w-full sm:w-[50%] h-fit flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                                <div className=" w-full h-full pl-1">
                                    <CInputTextArea name="description" title="توضیحات" custom_class="min-h-[100px]" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px]  pb-[15px] sm:pb-[30px]">
                        <div className=" w-full   flex flex-col sm:flex-row items-center">
                            <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                                <div className=" w-[50%] h-full pl-1 flex items-center">
                                    <span className="text-sm mx-2">فعال</span>
                                    <div className="flex flex-col justify-center items-center">
                                        <span className="text-[10px]  mb-2 text-center ">وضعیت گروه شغلی</span>
                                        <CToggle name="status" defaultChecked={true} />
                                    </div>
                                    <span className="text-sm mx-2">غیر فعال</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h2 className="sm:text-xl text-lg font-bold mt-[30px] mb-[10px]">تنظیمات گروه‌شغلی</h2>
                    {settingsField.map((item: any, index: number) =>
                        <>
                            {item.type == 1 &&
                                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                                            <div className=" w-[50%] h-full pl-1 flex items-center">
                                                <span className="text-sm mx-2">{item.configs[1].value}</span>
                                                <div className="flex flex-col justify-center items-center">
                                                    <span className="text-[10px]  mb-2 text-center ">{item.title}</span>
                                                    <CToggle name={`daynamic_${item.id}`} defaultChecked={true} />
                                                </div>
                                                <span className="text-sm mx-2">{item.configs[0].value}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {item.type == 2 &&
                                <div key={index} className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                                    <div className=" w-full   flex flex-col sm:flex-row items-center">
                                        <div className=" w-full sm:w-[50%] h-[50px] flex sm:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                                            <div className=" w-full h-full pl-1">
                                                <CInputText name={`daynamic_${item.id}`} title={item.title} type="text" required={true} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                        </>
                    )}

                    <div className=" w-full  flex items-center mt-[20px]">
                        {CtxLoad.displayLoadingBtn ?
                            <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                            :
                            <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                        }
                        <Link to='/p/settings/job-groups'>
                            <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                        </Link>
                    </div>
                </div>
            </div>

        </form>
    )
}
